import { IconProps } from "../../utils/global-types/global-types";

const VerifiedIcon = ({ className, ...rest }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 18 18"
    className={className || "w-[18px] h-[18px]"}
    {...rest}
  >
    <path
      fill="currentColor"
      d="M9 1.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15ZM7.5 12l-3-3 1.05-1.05L7.5 9.9l4.95-4.95L13.5 6l-6 6Z"
    />
  </svg>
);

export default VerifiedIcon;

